// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"654":"dcc4907c","917":"9ac7ea60","942":"15d7b514"}[chunkId] + ".chunk.css";
};